export default {
  SET_BANKS (state, payload) {
    state.bankList = payload;
  },
};
